export default __webpack_public_path__ + "static/media/19.7b06f6b7.jpg";